import React, { useState } from "react";
import { func } from "prop-types";
import { FaTrashAlt, FaEdit, FaLayerGroup } from "react-icons/fa";
import ReactTooltip from "react-tooltip";
import { Link } from "react-router-dom";
import moment from "moment";

import DeleteWatchListEntryModal from "../../delete-watch-list-entry-modal";
import DetailsModal from "../../../../../components/modals/details-modal";

import { watchListEntryType } from "../../../../../prop-types";
import routesConfig from "../../../../../routes/routes-config";
import useRoles from "../../../../../components/hooks/useRoles";
import JSONFormatter from "./JSONFormatter";

const WatchListEntryTableRow = ({
  watchListEntry,
  handleDelete,
  hidePercent,
  canEdit,
}) => {
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenDetails, setIsOpenDetails] = useState(false);
  // const { country } = watchListEntry.addresses[0] || {};
  const { isCustomerSupport } = useRoles();
  const modifiedDetailsJSON =
    !hidePercent ? JSON.stringify({
      ...JSON.parse(watchListEntry.detailsJson),
      matchPercent: watchListEntry.matchPercent,
    }) : watchListEntry.detailsJson


  const toggleDelete = () => {
    setIsOpenDelete(!isOpenDelete);
  };

  const toggleDetails = () => {
    setIsOpenDetails(!isOpenDetails);
  };

  const applyActionButtons = (watchList) => {
    if (
      watchList &&
      watchList.category &&
      !watchList.category.startsWith("Custom") &&
      watchList.category !== "DefaultManual"
    ) {
      return "";
    }

    if (!canEdit) {
      return "";
    }

    if (isCustomerSupport) {
      return (
        <React.Fragment>
          <ReactTooltip id="delete-icon" type="error">
            <span>Delete</span>
          </ReactTooltip>
          <ReactTooltip id="edit-icon" type="warning">
            <span>Edit</span>
          </ReactTooltip>
          <FaEdit
            className="ml-3"
            size="1.3em"
            data-tip
            data-for="edit-icon"
            color="gray"
          />
          <FaTrashAlt
            className="ml-3"
            size="1.3em"
            data-tip
            data-for="delete-icon"
            color="gray"
          />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <ReactTooltip id="delete-icon" type="error">
          <span>Delete</span>
        </ReactTooltip>
        <ReactTooltip id="edit-icon" type="warning">
          <span>Edit</span>
        </ReactTooltip>

        <Link
          to={
            watchList.updateUrl !== null
              ? `${watchList.updateUrl}/${watchListEntry.id}`
              : routesConfig.updateWatchListEntryPage.path.replace(
                ":id",
                watchListEntry.id
              )
          }
        >
          <FaEdit
            className="ml-3"
            size="1.3em"
            data-tip
            data-for="edit-icon"
            color="orange"
          />
        </Link>
        <FaTrashAlt
          className="ml-3"
          size="1.3em"
          data-tip
          data-for="delete-icon"
          color="red"
          onClick={toggleDelete}
        />
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <tr>
        <td className="empty-td" />
        <td>{watchListEntry.watchList.type}</td>
        <td className="watchlistname">{watchListEntry.watchList.name}</td>
        {!hidePercent ? <td>{watchListEntry.matchPercent}</td> : null}
        <td className="fullname-td">
          {watchListEntry.name && watchListEntry.name.fullName}
        </td>
        <td className="first-name-td">
          {watchListEntry.name && watchListEntry.name.firstName}
        </td>
        <td className="middle-name-td">
          {watchListEntry.name && watchListEntry.name.middleName}
        </td>
        <td className="last-name-td">
          {watchListEntry.name && watchListEntry.name.lastName}
        </td>
        <td>
          {watchListEntry.birthDate &&
            moment(watchListEntry.birthDate).format("DD.MM.YYYY")}
        </td>
        <td>{watchListEntry.nationality && watchListEntry.nationality.name}</td>
        <td>
          {watchListEntry.identifications &&
            watchListEntry.identifications.length > 0 &&
            watchListEntry.identifications[0].number}
        </td>

        <td className="center">
          <ReactTooltip id="details-icon" type="info">
            <span>Details</span>
          </ReactTooltip>
          <FaLayerGroup
            size="1.3em"
            data-tip
            data-for="details-icon"
            color="cornflowerblue"
            onClick={toggleDetails}
          />
          {applyActionButtons(watchListEntry && watchListEntry.watchList)}
        </td>
        <td className="empty-td" />
      </tr>
      <DeleteWatchListEntryModal
        toggle={toggleDelete}
        handleDelete={handleDelete}
        id={watchListEntry.id}
        isOpen={isOpenDelete}
      />

      <DetailsModal
        toggle={toggleDetails}
        isOpen={isOpenDetails}
        modalHeader={watchListEntry.watchList.name}
        modalBody={
          <JSONFormatter data={JSON.parse(modifiedDetailsJSON)} />
        }
        url={watchListEntry.watchList.publicUrl}
      />
    </React.Fragment>
  );
};

WatchListEntryTableRow.propTypes = {
  handleDelete: func.isRequired,
  watchListEntry: watchListEntryType.isRequired,
};

export default WatchListEntryTableRow;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/watch-list-entries-table/watch-list-entry-table-row/WatchListEntryTableRow.jsx